import type {CustomEventAlternative, CustomEventDefinition} from 'common/report/util/saved-entities/types';
import {EventItem} from 'common/widgets/query-block/events-menu/types';

export function hasUserFilters(customEvent, customEvents) {
  if (!customEvent || !customEvent.alternatives || customEvent.is_collect_everything_event) {
    // Guard against empty customEvent reference, regular events and Autotrack events (which never have user filters)
    return false;
  }

  const alternatives = customEvent.alternatives;

  const hasUserFiltersOnThisEvent = alternatives.some((alternative) => {
    return alternative.valid_segfilter && alternative.valid_segfilter.filters.some((f) => f.property.source === `user`);
  });
  if (hasUserFiltersOnThisEvent) {
    return true;
  }

  return alternatives.some((alternative) => {
    const subEventMatch = alternative.event.match(/\$custom_event:(.+)/);
    if (subEventMatch) {
      const subEventId = subEventMatch[1];
      if (!customEvents) {
        return false;
      }
      const subEvent = customEvents.find((event) => subEventId === `${event.id}`);
      return hasUserFilters(subEvent, customEvents);
    }
  });
}

function doesAlternativesHaveAutotrackEvent(
  eventToCheck: CustomEventDefinition,
  nonCustomEvents: EventItem[],
  customEvents: CustomEventDefinition[],
) {
  return eventToCheck.alternatives.find((alternativeEvent: CustomEventAlternative) => {
    const eventName = alternativeEvent.event;
    const isNotCustomEvent = !!nonCustomEvents.find((ev: EventItem) => ev.value === eventName);
    if (isNotCustomEvent) {
      return false;
    } else {
      const customEvent = customEvents.find((ev: CustomEventDefinition) => ev.value === eventName);
      // if it can't find the event as autotrack or custom event, might be hidden. ignore for now.
      if (!customEvent) {
        return false;
      } else if (customEvent.isCollectEverything) {
        return true;
      } else {
        // keep going until we hit a non custom event or an autotrack event
        return doesAlternativesHaveAutotrackEvent(customEvent, nonCustomEvents, customEvents);
      }
    }
  });
}

export function getNonAutotrackCustomEvents(customEvents: CustomEventDefinition[], nonCustomEvents: EventItem[]) {
  return customEvents.filter((eventToCheck: CustomEventDefinition) => {
    if (eventToCheck.isCollectEverything) {
      return false;
    } else {
      // try to find an alernative event that is an autotrack event, disclude it if we find one
      return !doesAlternativesHaveAutotrackEvent(eventToCheck, nonCustomEvents, customEvents);
    }
  });
}
